// @vendors
const Immutable = require('immutable');
const moment = require('moment');
const momentTz = require('moment-timezone');
const get = require('lodash/object/get');
const reduce = require('lodash/collection/reduce');
const trim = require('lodash/string/trim');

// @actions
const signaturePatternActions = require('actions/signaturePattern');
const errorActions = require('actions/brokerError');

// @helpers
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost } = require('utilities/APIRequestHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { es: { DATE_FORMAT_WITH_DASHES_DATETIME }} = require('commonsConstants/dateFormatTypes');


// @constants
const {
    DATE_FORMAT_API,
    BROKER_SUBSCRIPTION_TIPO_BOLSA,
    BROKER_SUBSCRIPTION_TIPO_OPERACION,
    BROKER_SUBSCRIPTION_DISCRIMINADOR_CLAUSULA,
    BROKER_MIFID_VERSION_2,
    CONNECTION_CHANNEL_INTERNET,
    BROKER_CORPORATE_OPERATIONS_SUBSCRIPTION_PRODUCT_TYPE,
    CHARGE_ACCOUNT_PREFIX,
    BROKER_ALERT_BUY_BUTTON_STOCK,
    BROKER_ORDER_TYPE_SUBSCRIPTION
} = require('constants/index');

const {
    BROKER_SUBSCRIPTION_START,
    BROKER_SUBSCRIPTION_CHANGE_MANIFEST,
    BROKER_SUBSCRIPTION_VALIDATE_STEP,
    BROKER_SUBSCRIPTION_FINISH,
    BROKER_SUBSCRIPTION_DOCUMENTS_READ
} = require('constants/actionTypes');

const SUBSCRIPTION_AGENT_ID = 'WEB';

const setSubscriptionInfo = (selectedContract, selectedOperation) => {
    const account = get(selectedContract, 'cuenta');
    const associatedAccount = get(selectedContract, 'associatedAccount');
    const selectedContractInfo = get(selectedContract, 'contract');

    return {
        type: BROKER_SUBSCRIPTION_START,
        payload: {
            cuenta: account,
            operation: selectedOperation,
            contract: selectedContractInfo,
            owner: get(selectedContract, 'owner'),
            walletAccountType: get(selectedContract, 'walletAccountType'),
            selectedContract,
            associatedAccount
        }
    };
};

const startFromMifid = (selectedContract, selectedOperation) => (dispatch) => {
    dispatch(setSubscriptionInfo(selectedContract, selectedOperation));
};

const changeManifest = () => dispatch => {
    dispatch({
        type: BROKER_SUBSCRIPTION_CHANGE_MANIFEST,
        payload: {}
    });
};

const validateUI = dispatch => {
    dispatch({
        type: BROKER_SUBSCRIPTION_VALIDATE_STEP,
        payload: {}
    });
};

const finish = (response) => ({
    type: BROKER_SUBSCRIPTION_FINISH,
    payload: { response }
});

const generateMiFIDDisclaimers = (immBrokerConvenienceMiFIDTest) => {
    const immUSPersonDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'usPersonDisclaimers']);
    const immDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'disclaimers']);
    const immAllDisclaimers = Immutable.fromJS([]).merge(immUSPersonDisclaimers).merge(immDisclaimers);

    return immAllDisclaimers.map(immDisclaimer => immDisclaimer.get('description')).join(' | ');
};

const storeDocument = (subscriptionResponse, history) => (dispatch, getState) => {
    const immProfile = getState().profile;
    const immBrokerSubscription = getState().brokerSubscription;
    const immBrokerProductFile = getState().brokerProductFile;


    const momentEmittedDateTime = momentTz(Number(trim(get(subscriptionResponse, 'timestamp')))).tz("Europe/Madrid");
    const controlDigit = trim(immBrokerSubscription.get('digitodecontrol'));
    const productNumber = trim(immBrokerSubscription.getIn(['contract', 'product']));
    const contractNumber = trim(immBrokerSubscription.getIn(['contract', 'number']));
    const idContract = `${CHARGE_ACCOUNT_PREFIX}${controlDigit}${productNumber}${contractNumber}`;
    const marketName = trim(immBrokerProductFile.get('marketName')) || '';

    const owner = trim(immBrokerSubscription.get('owner'));
    const momentEndDate = moment(immBrokerSubscription.getIn(['value', 'endDate']));

    const query = {
        productKID: '',
        contract: '',
        marketingReport: '',
        infoCcv: '',
        sendOrder: 'No',
        idOrder: '',
        market: marketName,
        termValidity: momentEndDate.format(DATE_FORMAT_API),
        holders: owner,
        leafletSusbcription: trim(immBrokerSubscription.get('linkTriptico')),
        cnmvDocumentation: trim(immBrokerSubscription.get('linkCNMV')),
        ccv: idContract,
        ccc: trim(get(subscriptionResponse, 'cuentaAsociada.codbban')),
        idContract: idContract,
        email: trim(PersonalDataHelper.getEmail(immProfile)),
        clientAlias: trim(immProfile.get('nombreCliente')),
        isin: trim(immBrokerSubscription.getIn(['value', 'isin'])),
        isinDescribe: trim(immBrokerSubscription.getIn(['value', 'descriptionValue'])),
        channel: CONNECTION_CHANNEL_INTERNET,
        orderType: BROKER_ORDER_TYPE_SUBSCRIPTION,
        productType: BROKER_CORPORATE_OPERATIONS_SUBSCRIPTION_PRODUCT_TYPE,
        sharesNumber: '',
        sharesAmount: '',
        orderCondition: '',
        conditionPrize : '',
        currency: ' ', // @hardcoded To confirm
        mifidWarningText: generateMiFIDDisclaimers(getState().brokerConvenienceMiFIDTest) ,
        dateTime: momentEmittedDateTime.format(DATE_FORMAT_WITH_DASHES_DATETIME)
    };

    const url = apiURLBuilder.getURL('communication');

    APIPost(dispatch, url, { query }).catch(() => dispatch(errorActions.show('', true, history)));
}

const mifidDisclaimersResponse = (immBrokerConvenienceMiFIDTest) => {
    const isUsingMifidv2 = immBrokerConvenienceMiFIDTest.get('mifidVersion') === BROKER_MIFID_VERSION_2;
    let disclaimers = undefined;

    if (isUsingMifidv2) {
        const mifidv2AllDisclaimers =
            immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'disclaimers'])
            .merge(immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'usPersonDisclaimers']))
            .toJS();

        disclaimers = reduce(mifidv2AllDisclaimers, (result, disclaimer, index) => {
            const disclaimerKey = `disclaimer_${index + 1}`;
            const disclaimerText = trim(get(disclaimer, 'description'));

            result[disclaimerKey] = `${trim(get(disclaimer, 'id'))} | ${disclaimerText}`;

            return result;
        }, {});
    }

    return disclaimers;
};

const performOperation = (dispatch, getState, token, history) => {
    const immBrokerSubscription = getState().brokerSubscription;
    const immCorporatesOperations = getState().brokerCorporatesOperations;
    const immBrokerLegalDocumentation = getState().brokerLegalDocumentation;
    const uuid = immBrokerLegalDocumentation.get('uuid');

    const selectedContract = immCorporatesOperations.get('selectedContract');
    const url = apiURLBuilder.getURL('brokerSuscripcion');

    const contractNumber = immBrokerSubscription.getIn(['contract', 'number']);
    const productNumber = immBrokerSubscription.getIn(['contract', 'product']);
    const valueCode = immBrokerSubscription.getIn(['value', 'valueCode']);
    const emisionCode = immBrokerSubscription.getIn(['value', 'codigoEmision']);

    const immBrokerConvenienceMiFIDTest = getState().brokerConvenienceMiFIDTest;
    const mifidScore = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'score']);
    const mifidScoring = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'scoring']);
    const mifidWasApplied = immBrokerConvenienceMiFIDTest.get('started');

    const immRights = getState().brokerMyInvestments.getIn(['products', 'others', 'stocks']);
    const immRight = immRights.find(immRight => {
        return (
            immRight.get('valueCode') === valueCode &&
            immRight.get('emisionCode') === emisionCode &&
            immRight.get('contractNumber') === contractNumber &&
            immRight.get('product') === productNumber
        );
    });

    const immProductFile = getState().brokerProductFile;
    const unitPrice = immProductFile.getIn(['productValue', 'amount'], '');
    const productManager = immProductFile.get('companyName', '');

    const query = {
        initQuantity: immRight ? immRight.get('shares') : 0,
        proportion: immBrokerSubscription.getIn(['value', 'proportion']),
        codigoEmision: immBrokerSubscription.getIn(['value', 'codigoEmision']),
        codigoValor: immBrokerSubscription.getIn(['value', 'codigoValorInterno']),
        contrato: {
            numerodecontrato: contractNumber,
            producto: productNumber
        },
        dataToken: token,
        digitoDeControl: selectedContract.getIn(['cuenta', 'digitodecontrol']),
        tipoBolsa: BROKER_SUBSCRIPTION_TIPO_BOLSA,
        tipoOperacion: BROKER_SUBSCRIPTION_TIPO_OPERACION,
        productIsin: immBrokerSubscription.getIn(['value', 'isin']),
        shares: immRight ? immRight.get('shares') : 0,
        micCode: trim(immBrokerSubscription.getIn(['value', 'iso'])),
        productType: BROKER_ALERT_BUY_BUTTON_STOCK,
        unitPrice: unitPrice,
        agentId: SUBSCRIPTION_AGENT_ID,
        productManager: productManager,
        convenientRegistry: immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'isConvenient']),
        evaluateRegistry: mifidWasApplied,
        disclaimers: mifidDisclaimersResponse(immBrokerConvenienceMiFIDTest),
        marketTargetRegistry: mifidScore >= mifidScoring,
        necessaryConvenienceTestNote: mifidScoring,
        necessaryTargetMarketNote: immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'targetMarketKnowledgeAndExperience']),
        testConveniencyResult: mifidScore,
        documentationId: uuid
    };

    const requestData = {
        header: {
            version: 2
        },
        query
    };

    APIPost(dispatch, url, requestData).then(
        (response) => {
            dispatch(finish(response)),
            dispatch(storeDocument(response, history))
        },
        function(response) {
            const errorKey = get(response, ['body', 'error'], '');
            dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
        }
    );
};

const validateSignature = (dispatch, getState, history) => {
    signaturePatternActions.validateAndExecute(dispatch, getState, (dispatch, getState, token) =>
        performOperation(dispatch, getState, token, history)
    );
};

const validate = (dispatch, getState, history) => {
    const immBrokerSubscription = getState().brokerSubscription;

    const url = apiURLBuilder.getURL('brokerSuscripcionValidacion');

    const requestData = {
        codEmision: immBrokerSubscription.getIn(['value', 'codigoEmision']),
        codValor: immBrokerSubscription.getIn(['value', 'codigoValorInterno']),
        contrato: {
            numerodecontrato: immBrokerSubscription.getIn(['contract', 'number']),
            producto: immBrokerSubscription.getIn(['contract', 'product'])
        },
        discriminadorClausula: BROKER_SUBSCRIPTION_DISCRIMINADOR_CLAUSULA,
        fechaSituacion: moment().format(DATE_FORMAT_API),
        tipoOperacion: BROKER_SUBSCRIPTION_TIPO_OPERACION
    };

    APIPost(dispatch, url, { query: requestData }).then(
        () => validateSignature(dispatch, getState, history),
        function(response) {
            const errorKey = get(response, ['body', 'error'], '');
            dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
        }
    );
};

const submitOperation = (history) => (dispatch, getState) => {
    validateUI(dispatch);

    const immBrokerSubscription = getState().brokerSubscription;

    if (immBrokerSubscription.get('valid')) {
        validate(dispatch, getState, history);
    }
};

const setDocumentsRead = () => (dispatch) => dispatch({
    type: BROKER_SUBSCRIPTION_DOCUMENTS_READ
});

module.exports = {
    setSubscriptionInfo,
    startFromMifid,
    changeManifest,
    submitOperation,
    finish,
    setDocumentsRead
};
